module.exports = __webpack_public_path__ + "files/74a3bc2064a1776dbfd847a2815a85f6.png";